import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="story-tagger"
export default class extends Controller {
  static targets = [
    "fileInput",
    "uploadPrompt",
    "videoPreview",
    "imagePreview",
    "instruction",
    "tagContainer",
    "productSelect",
  ];

  // 1. Preview the video/image when selected
  loadFile(event) {
    const file = event.target.files[0];
    if (!file) return;

    const url = URL.createObjectURL(file);

    // Hide the upload prompt icon/text
    if (this.hasUploadPromptTarget) {
      this.uploadPromptTarget.classList.add("hidden");
    }

    // Check file type and route to the correct HTML tag
    if (file.type.startsWith("video/")) {
      this.videoPreviewTarget.src = url;
      this.videoPreviewTarget.classList.remove("hidden");
      this.imagePreviewTarget.classList.add("hidden");
    } else if (file.type.startsWith("image/")) {
      this.imagePreviewTarget.src = url;
      this.imagePreviewTarget.classList.remove("hidden");
      this.videoPreviewTarget.classList.add("hidden");
    }

    // Reveal the instruction to tap the screen
    if (this.hasInstructionTarget) {
      this.instructionTarget.classList.remove("hidden");
    }
  }

  // 2. Drop a tag when the user taps the video/image preview
  dropTag(event) {
    // Only allow one tag per story for MVP simplicity.
    // Clearing the innerHTML also removes the previous hidden inputs if they re-tap.
    this.tagContainerTarget.innerHTML = "";

    // Calculate percentage based on where they tapped
    // event.target ensures it works dynamically for both the <img> and <video> tag
    const rect = event.target.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    // Create the visual dot on the screen
    const dot = document.createElement("div");
    dot.className =
      "absolute w-4 h-4 bg-[#E47434] border-2 border-white rounded-full shadow-lg transform -translate-x-1/2 -translate-y-1/2 animate-bounce";
    dot.style.left = `${x}%`;
    dot.style.top = `${y}%`;
    this.tagContainerTarget.appendChild(dot);

    // Generate the hidden inputs for Rails nested attributes
    const inputX = document.createElement("input");
    inputX.type = "hidden";
    inputX.name = "story[story_tags_attributes][0][pos_x]";
    inputX.value = x.toFixed(2);

    const inputY = document.createElement("input");
    inputY.type = "hidden";
    inputY.name = "story[story_tags_attributes][0][pos_y]";
    inputY.value = y.toFixed(2);

    this.tagContainerTarget.appendChild(inputX);
    this.tagContainerTarget.appendChild(inputY);

    // Show the product selector dropdown
    this.productSelectTarget.classList.remove("translate-y-full");
  }
}
